import { Link as RouterLink } from 'react-router-dom';
import { Button, useTranslate } from 'react-admin';
import UploadFileIcon from '@mui/icons-material/UploadFile';

export const UploadButton = () => {
    const translate = useTranslate();
    return (
        <Button
            component={RouterLink}
            to="upload"
            label={translate('app.action.upload')}
            startIcon={<UploadFileIcon />}
        />
    );
};
